import React from "react";
import { Box, Button, Link, Typography } from "@mui/material";
import { TOKENS } from "./styled";

const STORAGE_KEY = "sed_cookie_notice_v1";

type Props = {
  /** Opens the privacy policy modal; omit to hide the link (no policy text). */
  onOpenPrivacy?: () => void;
};

const CookieBanner: React.FC<Props> = ({ onOpenPrivacy }) => {
  const [dismissed, setDismissed] = React.useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore storage errors (private mode, etc.) */
    }
    setDismissed(true);
  };

  return (
    <Box
      role="region"
      aria-label="Information cookies"
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
        bgcolor: TOKENS.PRIMARY_BLUE,
        color: TOKENS.WHITE,
        px: { xs: 2, sm: 3 },
        py: 1.5,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: 1.5,
        boxShadow: "0 -2px 12px rgba(0,0,0,0.18)",
      }}
    >
      <Typography sx={{ fontSize: "0.85rem", lineHeight: 1.5, flex: 1 }}>
        Ce service utilise uniquement les cookies nécessaires à son
        fonctionnement et fait appel à Google Maps pour la saisie d&apos;adresse.
        {onOpenPrivacy && (
          <>
            {" "}
            En savoir plus dans notre{" "}
            <Link
              component="button"
              type="button"
              onClick={onOpenPrivacy}
              sx={{
                color: TOKENS.WHITE,
                textDecorationColor: "currentColor",
                fontSize: "0.85rem",
                verticalAlign: "baseline",
              }}
            >
              politique de confidentialité
            </Link>
            .
          </>
        )}
      </Typography>
      <Button
        onClick={accept}
        variant="contained"
        size="small"
        sx={{
          bgcolor: TOKENS.WHITE,
          color: TOKENS.PRIMARY_BLUE,
          fontWeight: 700,
          flexShrink: 0,
          "&:hover": { bgcolor: TOKENS.GRAY_200 },
        }}
      >
        J&apos;ai compris
      </Button>
    </Box>
  );
};

export default CookieBanner;
